export default __webpack_public_path__ + "static/media/file-upload-error.f6aa8030.svg";